import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Button,
  Avatar,
  Box,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import logo from "../../../assets/Header/STM_logo.png";
import user from "../../../assets/Header/User.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getWishListItems } from "../../../STMPages/pages/testPrepDashboard/Api/DashboardApi";
import {
  SET_TEST_CART,
  SET_TEST_CART_LOADING,
  SET_WISHLIST,
  SET_WISHLIST_LOADING,
} from "../../../actions";
import { useWishlist } from "../../context/WishlistContext";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { getAllCartItem } from "../../../STMPages/pages/performance/purchaseTest/PurchaseTestApis";
import NotificationMenu from "./NotificationMenu";
import { getNotifications } from "../../api/notification";
export default function Header({ isSmallScreen, handleDrawerToggle }) {
  const purple = "#572575";
  const navigate = useNavigate();
  const location = useLocation();
  const [wishlistData, setWishListData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const [notificationAnchor, setNotificationAnchor] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [notificationLoading, setNotificationLoading] = useState(true);
  const [dashboardType, setDashboardType] = useState(null);

  const handleNotificationClick = (event) => {
if (!notificationAnchor) setNotificationAnchor(event.currentTarget);
  };
  // wishlist context
  const { wishlist, fetchWishlist, loading } = useWishlist();

  useEffect(() => {
    if (location.pathname.startsWith("/sap")) {
      fetchWishlist(); //  only for SAP pages
      setDashboardType("sap");
    } else {
      setDashboardType("test-prep");
    }
  }, [location.pathname]);

  const wishlistItems = Array.isArray(wishlist)
    ? wishlist.filter((item) => item && item !== "")
    : [];

  // fetch wishlist
  const testPrepwishlistItems = useSelector((state) => state.wishlist.items);
  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: SET_WISHLIST_LOADING, payload: true });
      try {
        const response = await getWishListItems(userId);
        setWishListData(response.data?.class_id || []);
        const wishlistItems = response.data || [];
        dispatch({ type: SET_WISHLIST, payload: wishlistItems });
      } catch (error) {
        console.error("Error fetching classes:", error);
      } finally {
        dispatch({ type: SET_WISHLIST_LOADING, payload: false });
      }
    };

    fetchData();
  }, [userId, dispatch]);

  // navigate to wishlist
  const handlenavigate = () => {
    if (location.pathname.startsWith("/test-prep")) {
      navigate("/test-prep/wishlist");
    } else if (location.pathname.startsWith("/sap")) {
      navigate("/sap/wishlist");
    } else {
      navigate("/test-prep/wishlist");
    }
  };

  const handleNavigateToTestCart = () => {
    navigate("/test-prep/my-exam-cart");
  };

  // logout
  const handleLogout = () => {
    localStorage.clear();
    handleCloseMenu();
    navigate("/login");
  };

  // profile handler
  const handleProfileClick = () => {
    handleCloseMenu();
    if (location.pathname.startsWith("/test-prep")) {
      navigate("/test-prep/profile");
    } else if (location.pathname.startsWith("/sap")) {
      navigate("/sap/profile");
    } else {
      // default route if neither matches
      navigate("/test-prep/profile");
    }
  };

  // menu handlers
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // cart Funcationality
  const testCartList = useSelector(
    (state) => state?.purchasetestcart?.items || []
  );

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: SET_TEST_CART_LOADING, payload: true });
      try {
        const response = await getAllCartItem(userId);
        setWishListData(response.data || []);
        const cartItem = response.data || [];
        dispatch({ type: SET_TEST_CART, payload: cartItem });
      } catch (error) {
        console.error("Error fetching classes:", error);
      } finally {
        dispatch({ type: SET_TEST_CART_LOADING, payload: false });
      }
    };

    fetchData();
  }, [userId, dispatch]);

  const navigateToZoomLink = () => {


    const zoomLink =
      "https://zoom.us/j/97485138279?pwd=Y1cwcXRHUWZWOFN3aTZOdmhHZm4yQT09#success";

    window.open(zoomLink, "_blank");
  };



  // fetch notifications

  const handlefetchNotification = async () => {
    try {
      setNotificationLoading(true);
      const response = await getNotifications({
        user_id: parseInt(userId),
        dashboard_type: dashboardType,
      });

      if (response.status === 200) {
        setNotifications(response?.data);
        setNotificationLoading(false);
      } else {
        setNotifications([]);
        setNotificationLoading(false);
      }
    } catch (error) {
      setNotifications([]);
      setNotificationLoading(false);
    }
  };

  useEffect(() => {
    if (userId && dashboardType) handlefetchNotification();
  }, [userId, dashboardType]);

  return (
    <>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{
          backgroundColor: "white",
          width: "100%",
          height: 73,
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
          justifyContent: "center",
        }}
      >
        <Toolbar
          sx={{
            minHeight: 73,
            px: 4,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {isSmallScreen && (
            <IconButton
              onClick={handleDrawerToggle}
              sx={{
                background: "linear-gradient(135deg, #572575, #572575)",
                color: "#fff",
                boxShadow: 2,
                "&:hover": {
                  background: "linear-gradient(135deg, #572575, #572575)",
                  transform: "scale(1.1)",
                },
                borderRadius: "8px",
                width: 35,
                height: 35,
                transition: "all 0.3s ease",
              }}
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Logo */}
          {!isSmallScreen && (
            <div style={{ marginLeft: 20 }}>
              <img
                src={logo}
                alt="STM Logo"
                style={{ height: 50, width: 70 }}
              />
            </div>
          )}
          {/* Right Actions */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button
              variant="contained"
              onClick={navigateToZoomLink}
              sx={{
                height: 40,
                bgcolor: "#572575",
                color: "white",
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",

                //  Add this to prevent blue hover
                ":hover": {
                  bgcolor: "#4b1e62", // darker purple
                },
              }}
              className="font-inter"
            >
              <Box
                sx={{
                  width: 25,
                  height: 25,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src="/svo.png" alt="svo" />
              </Box>
              Meet Online Experts
            </Button>

            {/* Icons */}
            {[
              {
                icon: (
                  <ShoppingCartOutlinedIcon
                    sx={{ color: purple }}
                    onClick={handleNavigateToTestCart}
                  />
                ),
                badge: testCartList?.length,
              },
              {
                icon: (
                  <FavoriteBorderIcon
                    sx={{ color: purple }}
                    onClick={handlenavigate}
                  />
                ),
                badge: location.pathname.startsWith("/sap")
                  ? wishlistItems.length
                  : testPrepwishlistItems?.length,
              },
              {
                icon: (
                  <NotificationsNoneOutlinedIcon
                    sx={{ color: purple }}
                    onClick={handleNotificationClick}
                  />
                ),
                badge: notifications?.length,
              },
            ].map((item, i) => (
              <IconButton
                key={i}
                sx={{
                  width: 45,
                  height: 45,
                  bgcolor: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "50%",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                {item.badge ? (
                  <Badge
                    badgeContent={item.badge}
                    color="error"
                    sx={{
                      ".MuiBadge-badge": {
                        width: 20,
                        height: 20,
                        fontSize: "0.75rem",
                      },
                    }}
                  >
                    {item.icon}
                  </Badge>
                ) : (
                  item.icon
                )}
              </IconButton>
            ))}

            {/* Avatar Menu */}
            <Avatar
              alt="User"
              src={user}
              sx={{
                width: 45,
                height: 45,
                border: "2px solid #ddd",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                cursor: "pointer",
              }}
              onClick={handleOpenMenu}
            />

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={handleProfileClick}>
                <ListItemIcon>
                  <AccountCircleIcon fontSize="small" />
                </ListItemIcon>
                Profile
              </MenuItem>
              <MenuItem onClick={handleCloseMenu}>
                <ListItemIcon>
                  <SettingsIcon fontSize="small" />
                </ListItemIcon>
                Settings
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>

 <NotificationMenu
              anchorEl={notificationAnchor}
              open={Boolean(notificationAnchor)}
              onClose={() => setNotificationAnchor(null)}
              notifications={notifications}
              setNotifications={setNotifications}
              notificationLoading={notificationLoading}
            />
           
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}
